import React, { useEffect, useState } from 'react'
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

export function formatNumberScale(number, usd = false, decimals = 0) {
  if (isNaN(number) || number === '' || number === undefined) {
    return usd ? '$0.00' : '0'
  }
  const num = parseFloat(number)
  const fullNum = Math.floor(num).toLocaleString('fullwide', {
    useGrouping: false,
  })
  const wholeNumberLength = fullNum.length

  if (wholeNumberLength >= 19) return usd ? '> $1000 Q' : '> 1000 Q'
  if (wholeNumberLength >= 16)
    return (usd ? '$' : '') + (num / Math.pow(10, 15)).toFixed(decimals) + ' Q'
  if (wholeNumberLength >= 13)
    return (usd ? '$' : '') + (num / Math.pow(10, 12)).toFixed(decimals) + ' T'
  if (wholeNumberLength >= 10)
    return (usd ? '$' : '') + (num / Math.pow(10, 9)).toFixed(decimals) + ' B'
  if (wholeNumberLength >= 7)
    return (usd ? '$' : '') + (num / Math.pow(10, 6)).toFixed(decimals) + ' M'
  if (wholeNumberLength >= 4)
    return (usd ? '$' : '') + (num / Math.pow(10, 3)).toFixed(decimals) + ' K'

  if (num < 0.0001 && num > 0) {
    return usd ? '< $0.0001' : '< 0.0001'
  }

  return (usd ? '$' : '') + num.toFixed(decimals)
}

const COLOR_CODES = ['#fb8500', '#beccf6', '#53cbc8', '#e5007a', '#2875c9', '#27cbc8']

const StackedAreaChart = ({ data, format }) => {
  const [chartData, setChartData] = useState([])

  useEffect(() => {
    if (!data.length) {
      return
    }

    const transformedData = data.map((dataPoint) => {
      return {
        date: dataPoint.timestamp,
        BTC: dataPoint.BTC || 0,
        ETH: dataPoint.ETH || 0,
        WGLMR: dataPoint.WGLMR || 0,
        DOT: dataPoint.DOT || 0,
        USDC: dataPoint.USDC || 0,
        xcUSDT: dataPoint.xcUSDT || 0,
      }
    })

    setChartData(transformedData)
  }, [data])

  return (
    <ResponsiveContainer width="95%" height={400}>
      <ComposedChart data={chartData}>
        <XAxis dataKey="date" />
        <YAxis
          tick={{ stroke: 'white' }}
          tickLine={{ stroke: 'white' }}
          tickFormatter={
            format === false
              ? (data) => {
                return data
              }
              : formatNumberScale
          }
          fontSize="14px"
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#05113b',
            border: 'none',
            borderRadius: '12px',
            fontSize: '12px',
          }}
          formatter={
            format === false
              ? (data) => {
                return data
              }
              : formatNumberScale
          }
        />
        <Legend />
        <CartesianGrid
          horizontal={true}
          vertical={true}
          opacity={0.2}
          strokeDasharray="8"
        />
        <Area
          type="monotone"
          dataKey="BTC"
          stackId="1"
          stroke={COLOR_CODES[0]}
          fill={COLOR_CODES[0]}
        />
        <Area
          type="monotone"
          dataKey="ETH"
          stackId="1"
          stroke={COLOR_CODES[1]}
          fill={COLOR_CODES[1]}
        />
        <Area
          type="monotone"
          dataKey="WGLMR"
          stackId="1"
          stroke={COLOR_CODES[2]}
          fill={COLOR_CODES[2]}
        />
        <Area
          type="monotone"
          dataKey="DOT"
          stackId="1"
          stroke={COLOR_CODES[3]}
          fill={COLOR_CODES[3]}
        />
        <Area
          type="monotone"
          dataKey="USDC"
          stackId="1"
          stroke={COLOR_CODES[4]}
          fill={COLOR_CODES[4]}
        />
        <Area
          type="monotone"
          dataKey="xcUSDT"
          stackId="1"
          stroke={COLOR_CODES[5]}
          fill={COLOR_CODES[5]}
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default StackedAreaChart
